import type { Locale } from 'antd/es/locale';
import ruRUImport from 'antd/locale/ru_RU';

// Under Vite, this deep CJS subpath sometimes comes through double-wrapped as
// `{ default: Locale }` instead of `Locale` — unwrap defensively either way, otherwise
// `ConfigProvider` silently falls back to English for every built-in antd string.
const ruRU: Locale = (ruRUImport as unknown as { default?: Locale }).default ?? ruRUImport;

// antd ships no Kyrgyz locale — built-in component strings (pagination, date picker, ...) fall
// back to Russian for `ky` too; the app's own i18n still translates everything else.
const ANTD_LOCALES: Record<string, Locale> = {
  ru: ruRU,
  ky: ruRU,
};

export function getAntdLocale(language: string): Locale {
  return ANTD_LOCALES[language] ?? ruRU;
}
